module.exports = __webpack_public_path__ + "static/media/bg3.4f1cb918.svg";